<template>
  <button
    class="btn"
    :class="{
      'btn-filled': theme === 'filled',
      'btn-outline': theme === 'outline',
      'btn-primary': type === 'primary',
      'btn-success': type === 'success',
      'btn-info': type === 'info',
      'btn-warning': type === 'warning',
      'btn-danger': type === 'danger',
    }"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: val => ['primary', 'success', 'info', 'warning', 'danger'].includes(val),
    },
    theme: {
      type: String,
      default: 'filled',
      validator: val => ['filled', 'outline'].includes(val),
    },
  },
}
</script>

<style lang="scss" scoped>
$button-primary: #00a350;
$button-info: #2e3e4e;
$button-danger: #e40000;

//need to fix when know design system for button
$button-success: #aaa;
$button-warning: #aaa;

.btn {
  font-size: 12px;
  min-width: 120px;
  opacity: 0.8;
  padding: 6px 12px;
  transition: opacity 70ms ease-in-out;

  &:hover {
    opacity: 1;
  }

  &.btn-filled {
    color: #fff !important;

    &.btn-primary {
      background-color: $button-primary;
      border-color: $button-primary;
    }

    &.btn-info {
      background-color: $button-info;
      border-color: $button-info;
    }

    &.btn-danger {
      background-color: $button-danger;
      border-color: $button-danger;
    }

    &.btn-primary,
    &.btn-info,
    &.btn-danger {
      &[disabled] {
        cursor: not-allowed;
        opacity: 0.4;
      }
    }
  }

  &.btn-outline {
    background-color: #fff;

    &.btn-primary {
      border-color: $button-primary;
      color: $button-primary !important;
    }

    &.btn-info {
      border-color: $button-info;
      color: $button-info !important;
    }

    &.btn-danger {
      background-color: $button-danger;
      border-color: $button-danger !important;
    }
  }

  &.btn-primary,
  &.btn-info,
  &.btn-danger {
    &[disabled] {
      cursor: not-allowed;
      opacity: 0.4;
    }
  }
}
</style>
